// extracted by mini-css-extract-plugin
export default {"actions":"AssignConfig_actions__7LCal","label":"AssignConfig_label__W1Ipn"};